import React, { Component } from 'react';
import { Container, Row, Col, ListGroup, ListGroupItem } from 'reactstrap';
import ContactForm from './ContactForm';
import RkMap from './RkMap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faPhone from '@fortawesome/fontawesome-free-solid/faPhone';
import faEnvelope from '@fortawesome/fontawesome-free-solid/faEnvelope';
import * as contactActions from '../../actions/contactActions';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { bindActionCreators } from 'redux';

class ContactPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contactSubmission: {},
      errors: {},
      sending: false,
    };
  }

  updateSubmissionState = (event) => {
    const field = event.target.id;
    let submission = Object.assign({}, this.state.contactSubmission);
    submission[field] = event.target.value;
    this.setState({ contactSubmission: submission });
  };

  onSend = (event) => {
    event.preventDefault();
    if (!this.formIsValid) return;
    this.setState({ sending: true });
    const { contactSubmission } = this.state;
    this.props.actions
      .sendContactForm(contactSubmission)
      .then(() => {
        toast.success('Message sent.');
        this.setState({ sending: false });
        this.clearForm();
      })
      .catch((error) => {
        toast.error(error.message);
        this.setState({ saving: false });
      });
  };

  clearForm = () => {
    this.setState({
      contactSubmission: {},
    });
  };

  formIsValid = () => {
    const { contactSubmission } = this.state;
    let errors = {};
    let isValid = true;

    if (contactSubmission.name === '') {
      errors.name = 'Please enter your name';
      isValid = false;
    }
    if (contactSubmission.email < '') {
      errors.email = 'Please enter your email.';
      isValid = false;
    }
    if (contactSubmission.phone !== '') {
      //errors.phone = 'Please enter a valid phone number';
    }
    if (contactSubmission.message === '') {
      errors.message = 'Please enter a message';
      isValid = false;
    }

    this.setState({ errors: errors });
    return isValid;
  };

  render() {
    return (
      <div>
        <Container fluid={true}>
          <Row>
            <Col md={12}>
              <h1 className="text-center my-4">Contact Us</h1>
            </Col>
          </Row>

          <Row>
            {/*
              <Col md={12}>
                <h2 className="text-center my-5">(870) 437-5353</h2>
              </Col>
*/}

            <Col md={7}>
              <RkMap />
            </Col>

            <Col md={5}>
              <ListGroup className="text-center contact">
                <ListGroupItem>
                  <FontAwesomeIcon icon={faPhone} className="mr-2" />
                  (870) 437-5353
                </ListGroupItem>
                <ListGroupItem>
                  <FontAwesomeIcon icon={faEnvelope} className="mr-2" />
                  320 S. Commercial St.
                </ListGroupItem>
                <ListGroupItem className="ml-4">Unit #6072</ListGroupItem>
                <ListGroupItem className="ml-4">
                  Branson, MO 65616
                </ListGroupItem>
              </ListGroup>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <h2 className="text-center my-4">Send Us A Message</h2>
              <ContactForm
                contactSubmission={this.state.contactSubmission}
                onSend={this.onSend}
                onChange={this.updateSubmissionState}
                errors={this.state.errors}
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(contactActions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(ContactPage);



// WEBPACK FOOTER //
// ./src/components/contact/ContactPage.js